import { render, staticRenderFns } from "./ComplexMenu.vue?vue&type=template&id=2c88196c&"
import script from "./ComplexMenu.vue?vue&type=script&lang=ts&"
export * from "./ComplexMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ComplexMenu.vue?vue&type=style&index=0&id=2c88196c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports